import { c as _c } from "react/compiler-runtime";
import { Flame } from 'lucide-react';
import { SparkContentSection } from './SparkContentSection';
import { useContentList } from '@/lib/hooks/useContent';
import { ContentCard } from '@/components/content/ContentCard';
export function SparkInspiration() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["case-study", "playbook"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: t0,
      status: "published",
      visibility: "public",
      systemTags: ["@featured=true"],
      limit: 6
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isLoading
  } = useContentList(t1);
  let t2;
  if ($[2] !== data?.pages || $[3] !== isLoading) {
    const items = data?.pages?.flatMap(_temp) || [];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        href: "/content?type=case-study&type=playbook",
        label: "Browse all Inspiration"
      };
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = <SparkContentSection icon={Flame} iconClassName="text-primary-500" title="Inspiration and Guides" subtitle="Real examples and playbooks from those who've done it." footerLink={t3} bgClassName="bg-[#fffaf4]" isLoading={isLoading}>{items.map(_temp2)}</SparkContentSection>;
    $[2] = data?.pages;
    $[3] = isLoading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(content) {
  return <ContentCard showTypeBadge={true} key={content.id} content={content} showTags={true} showWhen={false} />;
}
function _temp(page) {
  return page.content;
}